app.service('cartBox', function ($global, console, html, front, cookie, pageConfig) {
	var $self = false;
	var itemsIdsInCart = false;
	var ajax = false;
	var isInit = false;

	//test kopiowania

	function emptyCartCookie() {
		$self.empty().html(`
			<a href="/cart.bhtml" class="empty" aria-label="Otwórz koszyk">
				<span class="screen-reader-text">
					Koszyk (0)
				</span>
			</a>
		`);
	}

	function initRefresh() {
		var cartCookie = front.euro ? 'euroCart' : 'oleoleCart';
		if (cookie.isEmpty(cartCookie)) {
			emptyCartCookie();
		} else {
			refresh();
		}
	}
	function refreshSuccess(response) {
		$self.empty().html(response);
		$self.attr('data-quantity', getCount());
		html.add('load-cart-box');
		itemsIdsInCart = $('#items-in-cart', $self).val().split('|');
		$('#items-in-cart', $self).remove();
		$(document).trigger('cartReady', getBasketConfig());
	}
	function getBasketConfig(config) {
		if (config) {
			return pageConfig.getData('basket')[config];
		} else {
			return pageConfig.getData('basket');
		}
	}

	function getItemProperty(id, prop) {
		return getBasketConfig('items')
			.filter(function (item) {
				return item.id === id;
			})
			.map(function (item) {
				return item[prop];
			})[0];
	}

	function getElements() {
		var items = getBasketConfig('items');
		if (items) {
			return items.map(function (item) {
				return item.id;
			});
		} else {
			return [];
		}
	}
	function getAccessories(id) {
		return getItemProperty(id, 'accessories');
	}
	function getServices(id) {
		return getItemProperty(id, 'services');
	}
	function getWarranty(id) {
		return {
			warrantyId: getItemProperty(id, 'warranty'),
			warrantyPaymentType: getItemProperty(id, 'warrantyPaymentType')
		};
	}
	function getPartnerSubscriptions(id) {
		return getItemProperty(id, 'partnerSubscriptions');
	}
	function getCount() {
		return getBasketConfig('quantity');
	}
	function isOutlet() {
		return getBasketConfig('isOutlet');
	}
	function abortRefresh() {
		if (ajax) {
			ajax.abort();
		}
	}
	function refresh() {
		if ($self.length) {
			abortRefresh();
			ajax = $.ajax({
				url: '/refresh-cart.ltr',
				method: 'POST',
				cache: false,
				success: function (html) {
					refreshSuccess(html);
				},
				error: function () {
					console.log('refreshCartBox ERROR');
				}
			});
		}
	}
	function setEvents() {
	}
	function itemsInCart() {
		return itemsIdsInCart.slice();
	}
	function init() {
		if (!isInit) {
			$self = $('#cart-box');
			$self.attr('data-quantity', getCount());
			setEvents();
			initRefresh();
			isInit = true;
		}
	}
	$global('cartRefresh', refresh);
	return {
		init: init,
		abortRefresh: abortRefresh,
		refresh: refresh,
		getElements: getElements,
		getAccessories: getAccessories,
		getServices: getServices,
		getWarranty: getWarranty,
		getPartnerSubscriptions,
		getCount: getCount,
		itemsInCart: itemsInCart,
		isOutlet: isOutlet
	};
});
